import { createBrowserRouter } from "react-router-dom";

import { authLoader } from "ui/navigation/loaders/protectedLoader";
import { Error } from "ui/pages/error/Error";
import { appRoutes } from "ui/navigation/routes/app/appRoutes";
import { authRoutes } from "ui/navigation/routes/auth/authRoutes";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      hydrateFallbackElement: (
        <div className="flex h-dvh w-full items-center justify-center">
          <div className="loader" />
        </div>
      ),
      errorElement: <Error />,
      children: [
        {
          loader: authLoader,
          children: authRoutes,
        },
        ...appRoutes,
      ],
    },
  ],
  {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
    },
  }
);
